import React, {useMemo, useState} from 'react'
import Text from '../../components/text/Text'
import CallItem from './CallItem'
import {IProbeCall} from './types'
import {copyProbeText, isFailedCall} from './utils'

interface IProps {
    className?: string
    calls?: IProbeCall[]
}

const CallList: React.FC<IProps> = ({className, calls}) => {
    const [phase, setPhase] = useState('')
    const [failedOnly, setFailedOnly] = useState(false)

    const phases = useMemo(() => {
        const seen: string[] = []
        calls?.forEach(call => {
            if (call.phase && !seen.includes(call.phase)) seen.push(call.phase)
        })
        return seen
    }, [calls])

    const failedCount = useMemo(() => (calls || []).filter(isFailedCall).length, [calls])

    const filtered = useMemo(() => {
        return (calls || [])
            .filter(call => !phase || call.phase === phase)
            .filter(call => !failedOnly || isFailedCall(call))
    }, [calls, phase, failedOnly])

    const tabStyle = (active: boolean) =>
        `text-ti3 px-[10px] py-[4px] rounded-[5px] cursor-pointer ${
            active ? 'text-white bg-font01' : 'text-font02 bg-bg_gray01 hover:bg-line02'
        }`

    return (
        <div className={`bg-white rounded-[10px] p-[30px] shadow-normal ${className}`}>
            <div className={'flex items-center gap-x-[10px] flex-wrap'}>
                <Text className={'text-ti1 text-font01'}>Calls ({calls?.length ?? 0})</Text>
                {failedCount > 0 && <Text className={'text-body3 text-font_red'}>의심 {failedCount}건</Text>}
                {calls?.length > 0 && (
                    <Text
                        onClick={() => copyProbeText(JSON.stringify(calls, null, 2), 'calls 전체가')}
                        className={'text-body3 text-sub_blue cursor-pointer ml-auto'}>
                        calls 전체 복사
                    </Text>
                )}
            </div>
            <Text className={'text-body3 text-font03 mt-[4px]'}>
                거래소 응답 바디 원본입니다. HTTP 200이어도 바디 안에서 거절되는 경우가 흔하니 상태 코드만 보지 마세요.
            </Text>

            <div className={'mt-[16px] flex items-center gap-[8px] flex-wrap'}>
                <Text onClick={() => setPhase('')} className={tabStyle(phase === '')}>
                    all
                </Text>
                {phases.map(item => (
                    <Text key={item} onClick={() => setPhase(item)} className={tabStyle(phase === item)}>
                        {item}
                    </Text>
                ))}
                <Text
                    onClick={() => setFailedOnly(!failedOnly)}
                    className={`ml-[10px] ${tabStyle(failedOnly)}`}>
                    의심 호출만
                </Text>
            </div>

            <div className={'mt-[16px] space-y-[8px]'}>
                {filtered.length === 0 ? (
                    <Text className={'text-body2 text-font03'}>
                        {calls?.length ? '조건에 맞는 호출이 없습니다.' : '기록된 호출이 없습니다.'}
                    </Text>
                ) : (
                    filtered.map((call, idx) => <CallItem key={`${call.url}-${call.at}-${idx}`} call={call} />)
                )}
            </div>
        </div>
    )
}

export default CallList
